// B1.4: organization domain methods (move-only from client.ts).
import { ApiClientCore } from './http/core';

export class OrgApi extends ApiClientCore {
  // ─── Organization ───────────────────────────────────────────────────────────
  async getOrganization(): Promise<any> {
    return this.get('/api/v1/organizations/me');
  }
  async updateOrganization(data: any): Promise<any> {
    return this.put('/api/v1/organizations/me', data);
  }
}
